import * as React from 'react';
import * as Forms from '../../../components/form-elements/_index';
import { FlyoutSaveCancel } from '../../../components/flyout-components/FlyoutSaveCancel';
import { Address } from '../../../models/utilities/address';
import { DeliveryShipmentAction } from '../../models/shipments/shipment-action';
import { StateSelectList } from '../../../components/utility/states';
import { AppUtils } from '../../../utils/app-utils';
import { ModelValidator } from '../../../utils/model-validator';
import { ProvinceSelectList } from '../../../components/utility/provinces';
import { SelectListItem } from '../../../models/utilities/selectlist-item';
import { CountrySelectList } from '../../../components/utility/countrySelectList'; 

interface IProps {
    stop : DeliveryShipmentAction;
    onSave: any;
    onCancel: any;
    visible: boolean;
    truckId: number;
    truckVersion: string;
}

export const ShipmentEditDeliveryAddress = (props: IProps) => {

    const [phoneNumber, setPhoneNumber] = React.useState<string>("");
    const [editAddress, setEditAddress] = React.useState<Address>(new Address());
    const [saveAttempts, setSaveAttempts] = React.useState(0);
    const [errors, setErrors] = React.useState({} as any);

    React.useEffect(() => {
        if (props.visible && props.stop) {

            const tmpAddress = { ...props.stop.address };
            setEditAddress(tmpAddress);
            setPhoneNumber(props.stop.phoneNumber)
        }
    }, [props.visible]);


    const handleAddressChange = (e: any) => {
        const tmpAddress: any = { ...editAddress };
        tmpAddress[e.target.name] = e.target.value;
        setEditAddress(tmpAddress);
    };

    const handlePhoneNumberChange = (e: any) => {
        setPhoneNumber(e.target.value);
    };

    const onSave = () => {

        const valid = checkValidity();
        if (valid) {
            const tmpAddress = { ...editAddress };
            props.onSave(tmpAddress, phoneNumber);
        }
    };

    const checkValidity = () => {

        const tmpAddress = { ...editAddress };

        const msgs = ModelValidator.validate(tmpAddress);
        setErrors(msgs);
        setSaveAttempts(saveAttempts + 1);

        return AppUtils.IsEmpty(msgs) ? true : false;
    };


    const handleBlur = () => {
        if (saveAttempts > 0) {
            checkValidity();
        }
    };

    function getStateProvinceLabel() : string{
        switch (editAddress.country) {            
            case "US":
                return "State";
            case "CA":
                return "Province";
            default:
                return "State/Province";
        }
    }

    function getStateProvinceOptions(): Array<SelectListItem<string>> {
        switch (editAddress.country) {
            case "US":
                return StateSelectList;
            case "CA":
                return ProvinceSelectList;
            default:
                return [];
        }
    }

    return <div className="route-edit-delivery-address">

        <div className="row">
            <div className="col-md-12">
                <h1>Edit Delivery Address</h1>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Forms.TextInput
                    id="address-addressLine1"
                    type="text"
                    label="Address Line 1"
                    name="addressLine1"
                    error={errors.addressLine1}
                    value={editAddress.addressLine1}
                    onChange={handleAddressChange}
                    onBlur={handleBlur}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Forms.TextInput
                    id="address-addressLine2"
                    type="text"
                    label="Address Line 2"
                    name="addressLine2"
                    error={errors.addressLine2}
                    value={editAddress.addressLine2}
                    onChange={handleAddressChange}
                    onBlur={handleBlur}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Forms.TextInput
                    id="address-city"
                    type="text"
                    label="City"
                    name="city"
                    error={errors.city}
                    value={editAddress.city}
                    onChange={handleAddressChange}
                    onBlur={handleBlur}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Forms.SelectInput
                    id="address-stateprovince"
                    label={getStateProvinceLabel()}
                    name="stateProvince"
                    error={errors.stateProvince}
                    onBlur={handleBlur}
                    onChange={handleAddressChange}
                    options={getStateProvinceOptions()}
                    value={editAddress.stateProvince} />    
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Forms.TextInput
                    id="address-postalCode"
                    type="text"
                    label="Postal Code"
                    name="postalCode"
                    error={errors.postalCode}
                    value={editAddress.postalCode}
                    onChange={handleAddressChange}
                    onBlur={handleBlur}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Forms.SelectInput
                    id="address-country"
                    label="Country"
                    name="country"
                    error={errors.country}
                    onBlur={handleBlur}
                    onChange={handleAddressChange}
                    options={CountrySelectList}
                    value={editAddress.country} />
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Forms.TextInput
                    id="phone-number"
                    type="text"
                    label="Phone Number"
                    name="phoneNumber"
                    error={errors.phoneNumber}
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    onBlur={handleBlur}
                />
            </div>
        </div>
        <FlyoutSaveCancel
            onSave={onSave}
            onCancel={props.onCancel}
        />
    </div>

};
